import { render } from "./monacPage.vue?vue&type=template&id=44597142&scoped=true"
import script from "./monacPage.vue?vue&type=script&lang=js"
export * from "./monacPage.vue?vue&type=script&lang=js"

import "./monacPage.vue?vue&type=style&index=0&id=44597142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44597142"]])

export default __exports__